import {IComponentController, IComponentOptions, ILocationService, IScope} from "angular";
import {Opportunity} from "../../model/Opportunity";
import {GroupedOpportunityKey, OpportunityAction} from "../../../opportunity_actions/model/OpportunityAction";
import {Subscription} from "rxjs";
import {ACTION_SERVICE_NAME, CalculationNotificationServiceName} from "../../../utils/names/serviceNames";
import {ActionService} from "../../../opportunity_actions_service/service/ActionService";
import './OpportunityItem.scss';
import {CustomerOpportunityDialog} from "../customerOpportunityDialog/CustomerOpportunityDialog";
import {CalculationsNotificationService} from "../../../opportunities_service/service/CalculationsNotificationService";
import {CalculatorName} from "../../../calculations/model/Calculator";

interface OpportunityItemScope extends IScope {
    setOpportunityTextMaxHeight: (height: number) => void;
    opportunityTypeClass: string;
    opportunityActions: OpportunityAction[];
    opportunity: Opportunity;
    openMoreModal: ($event: MouseEvent) => void;
    markAsFailed: ($event: MouseEvent) => void;
    navigateTo: (customerId: number) => void;
}

export class OpportunityItem implements IComponentController {

    static instance: IComponentOptions = {
        template: require('./OpportunityItem.html'),
        controller: [
            '$scope',
            ACTION_SERVICE_NAME,
            CalculationNotificationServiceName,
            '$location',
            '$mdDialog',
            OpportunityItem
        ],
        bindings: {
            opportunity: '<',
            opportunityActions: '<'
        }
    };


    private actionsSubscription: Subscription;
    private opportunity: Opportunity;
    private opportunityActions: OpportunityAction[];
    private textElement: JQLite;


    constructor(private $scope: OpportunityItemScope,
                private actionService: ActionService,
                private notificationService: CalculationsNotificationService,
                private $location: ILocationService,
                private $mdDialog: angular.material.IDialogService) {
        this.$scope = Object.assign($scope, {
            setOpportunityTextMaxHeight: this.setOpportunityTextElement,
            openMoreModal: this.openMoreModal,
            opportunityActions: [],
            markAsFailed: this.markAsFailed,
            navigateTo: this.navigateTo
        });
    }

    $onInit(): void {
        let opportunity = this.opportunity;
        this.$scope.opportunity = opportunity;
        this.$scope.opportunityTypeClass = this.getOpportunityTypeClass(opportunity);
        this.subscribeForOpportunityActions(opportunity);
        if (this.opportunityActions) {
            this.$scope.opportunityActions = this.opportunityActions;
        }
    }


    setOpportunityTextElement = (element: JQLite) => {
        this.textElement = element;
    };

    navigateTo = (customerId: number) => {
        this.$location.url(`/contact_profile/${customerId}?selectedTab=opportunity_tab`);
    };

    getOpportunityTypeClass = (opportunity: Opportunity): string => {
        switch (opportunity.calculator.name) {
            case CalculatorName.SAVINGS:
                return 'savings-notification';
            case CalculatorName.EQUITY_RATE_AND_TERM_REFINANCE:
                return 'rate-term-notification-wrapper ';
            case CalculatorName.EQUITY_CASH_OUT:
                return 'cash-out-notification-wrapper';
            case CalculatorName.RATE_CALCULATOR:
                return 'rate-notification';
            case CalculatorName.TRIGGER_LEADS:
                return 'trigger-leads-notification';
        }
    };

    markAsFailed = ($event) => {
        this.$mdDialog.show(
            this.$mdDialog.confirm()
                .title('Are you sure you want to remove this opportunity?')
                .textContent('This opportunity will be removed from the list untill it has fired again on this customer. ' +
                    'To prevent this from happening disable this calculation on the customer`s tab.')
                .ariaLabel('Remove opportunity')
                .targetEvent($event)
                .ok('Yes remove opportunity')
                .cancel('Cancel')
        )
            .then(() => {
                //    customer wants to mark opportunity as failed
                this.notificationService.markAsFailed(this.$scope.opportunity.id);
                this.removeItemFromList(this.opportunity);
            }, () => {
                //    customer changed his mind
            });
    };

    subscribeForOpportunityActions = (opportunity: Opportunity) => {
        this.actionsSubscription = this.actionService
            .getActionsObservable(new GroupedOpportunityKey(opportunity.customer.id, opportunity.calculator.id))
            .subscribe(action => this.$scope.opportunityActions.push(action))
    };

    openMoreModal = ($event) => {
        this.$mdDialog.show(CustomerOpportunityDialog.instance($event, this.$scope.opportunity, true, true));
    };

    private removeItemFromList(opportunity: Opportunity) {
        this.notificationService.opportunityRemoved(opportunity);
    }
}